import React from 'react';
import 'css/ViewListToolbar.css';
import {
    LiveDot,
    ToolbarContent,
    ToolbarIcon,
    ToolbarLink,
    ToolbarTitle,
    ToolbarWrapper,
} from './styled';
import StarIcon from 'images/star.svg';

const ViewListToolbar = (props) => {
    let toolbarIcon = null;

    if (props.icon === 'live') {
        toolbarIcon = <LiveDot />;
    } else if (props.icon === 'anbefalede') {
        toolbarIcon = <ToolbarIcon src={StarIcon} alt="Favorite icon" />;
    }

    return (
        <ToolbarWrapper>
            <ToolbarContent>
                {toolbarIcon}
                <ToolbarTitle
                    $fontSize={'16px'}
                    $fontWeight={'bold'}
                    $lh={'24px'}
                >
                    {props.title}
                </ToolbarTitle>
            </ToolbarContent>
            {props.link && (
                <ToolbarLink onClick={props.onLinkClickHandler}>
                    {props.link}
                </ToolbarLink>
            )}
        </ToolbarWrapper>
    );
};

export default ViewListToolbar;
